import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import RouteModal from './RouteModal';
import styles from './RouteBuilder.module.css';

export default function RouteBuilder() {
  const today = new Date().toISOString().split('T')[0];

  // список маршрутов
  const [start, setStart] = useState(today);
  const [end, setEnd] = useState(today);
  const [routes, setRoutes] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [listError, setListError] = useState(null);

  // модалка создания
  const [showModal, setShowModal] = useState(false);

  // загрузка списка
  const loadList = async () => {
    setLoadingList(true);
    setListError(null);
    try {
      const res = await api.get('/routes/by-date', {
        params: { startDate: start, endDate: end }
      });
      setRoutes(Array.isArray(res) ? res : []);
    } catch (e) {
      setListError(e.message || 'Ошибка загрузки');
    } finally {
      setLoadingList(false);
    }
  };

  React.useEffect(() => {
    loadList();
  }, []);

  return (
    <div className={styles.page}>
      <h1>Маршрутные листы</h1>

      <section className={styles.createSection}>
        <button
          className={styles.createBtn}
          onClick={() => setShowModal(true)}
        >
          Новый маршрут
        </button>
      </section>

      <div className={styles.content}>
        <section className={styles.listSection}>
          <h2>Существующие маршруты</h2>
          <div className={styles.filterRow}>
            <input
              type="date"
              value={start}
              onChange={e => setStart(e.target.value)}
            />
            <span>—</span>
            <input
              type="date"
              value={end}
              onChange={e => setEnd(e.target.value)}
            />
            <button
              className={styles.loadBtn}
              onClick={loadList}
              disabled={loadingList}
            >
              {loadingList ? 'Загрузка...' : 'Загрузить'}
            </button>
          </div>
          <ul className={styles.list}>
            {routes.map(r => (
              <li
                key={r.id}
                className={styles.item}
                onClick={() => window.location.href = `RouteBuilder/${r.id}`}
              >
                <span className={styles.number}>{r.route_number}</span>
                <span className={styles.date}>{r.route_date}</span>
                <span className={styles.status}>{r.route_status}</span>
              </li>
            ))}
            {!routes.length && !loadingList && (
              <li className={styles.empty}>Маршрутов не найдено</li>
            )}
          </ul>
          {listError && <div className={styles.error}>{listError}</div>}
        </section>
      </div>

      {showModal && (
        <RouteModal
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
);
}
